module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "doctor clearfix",
    class: _vm.type === 2 ? 'doctor1' : 'doctor2'
  }, [_c('router-link', {
    attrs: {
      "to": '/doctor/' + _vm.id + '?hideNav=1'
    }
  }, [_c('div', {
    staticClass: "head border-blue"
  }, [_c('img', {
    attrs: {
      "src": _vm.doctor.image,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [(_vm.type === 2) ? [_c('h2', [_vm._v(_vm._s(_vm.doctor.name) + " "), _c('span', {
    staticClass: "desc2 line1"
  }, [_vm._v(_vm._s(_vm.doctor.good_at))])]), _vm._v(" "), _c('p', {
    staticClass: "desc line1"
  }, [_vm._v(_vm._s(_vm.doctor.level_title))]), _vm._v(" "), _vm._m(0, false, false)] : [_c('div', [_c('h2', {
    staticClass: "line1"
  }, [_vm._v(_vm._s(_vm.doctor.name))]), _vm._v(" "), _vm._m(1, false, false)]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('span', {
    staticClass: "line1"
  }, [_vm._v(_vm._s(_vm.doctor.good_at))]), _vm._v(" "), _c('span', {
    staticClass: "line1"
  }, [_vm._v(_vm._s(_vm.doctor.level_title))])])]], 2)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("三甲医院")]), _vm._v(" "), _c('li', [_vm._v("急速回复")]), _vm._v(" "), _c('li', [_vm._v("专业有效")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("三甲医院")]), _vm._v(" "), _c('li', [_vm._v("急速回复")]), _vm._v(" "), _c('li', [_vm._v("专业有效")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3546eb56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doctor.vue
// module id = 600
// module chunks = 1